import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

import { Footer, Sidebar, Topbar } from './components';
import { createBrowserHistory } from 'history';
import { withRouter } from 'react-router-dom';
import { Values } from '../../values/Values';
import socketio from 'socket.io-client';
import { ServiceValues } from '../../values/ServiceValues';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { getUsuarioByLocalStorage } from '../../services/UsuarioService';


const browserHistory = createBrowserHistory();

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  espacamentoTop: {
    paddingTop: 64
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%',
    marginTop: 60
  },
  backgroundCinza: {
    backgroundColor: Values.cores.cinza
  },
  backgroundCorPrimaria: {
    backgroundColor: Values.cores.corPrimaria
  }
}));
function Main(props) {
  const { children, history } = props;
  const { usuarioLogado, setUsuarioLogado, getUsuarioLogado } = props.children.props.params;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [usuariosConectados, setUsuariosConectados] = useState([]);
  const auth = JSON.parse(localStorage.getItem('auth'));
  let socket = auth && socketio(ServiceValues.base_url_local, {
    query: { idUsuario: auth.result.idUsuario }
  });

  useEffect(() => {
    if ( socket ) {
      socket.on('conexaoAtiva', data => {
        console.log('conexao ativa -> ' + data);
      });
      socket.emit('salvarConexao', {idUsuario: auth.result.idUsuario});
      socket.on('usuariosConectados', data => {
        if(data.novoUsuario){
          if(data.novoUsuario.idUsuario !== auth.result.idUsuario) {
            NotificationManager.success('' + data.novoUsuario.nomeFantasia + ' acabou de entrar no sistema!');
          }
        }
        setUsuariosConectados(data.conexoes);
      });
      socket.on('usuarioDesconectado', data => {
        if(data.idUsuario !== auth.result.idUsuario) {
          NotificationManager.error('' + data.nomeFantasia + ' acabou de sair no sistema!');
        }
      });
    }


  }, []);

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  function logout() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    socket.emit('desconectarUsuario', auth.result.idUsuario);
    localStorage.removeItem('auth');
    history.push('/sign-in')
  }

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop,
        [classes.espacamentoTop]: !isDesktop
      })}
    >
      <NotificationContainer/>
      {
        !isDesktop &&
        <Topbar
          onSidebarOpen={handleSidebarOpen}
          history={history}
          usuariosConectados={usuariosConectados}
          logout={logout}
        />
      }
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        style={{
          marginTop: 10
        }}
        usuario={usuarioLogado}
        setUsuario={setUsuarioLogado}
        getUsuarioLogado={getUsuarioLogado}
        history={history}
      />
      {
        isDesktop &&
        <Topbar
          onSidebarOpen={handleSidebarOpen}
          history={history}
          usuariosConectados={usuariosConectados}
          logout={logout}
        />
      }
      <main
        className={classes.content}
      >
        { children }
        <Footer />
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default withRouter(Main);
